import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const StudentParentsInfo = ({ parents }) => (
  <div>
    {parents.map(parent =>
      <div key={parent.id}>
        <h5>{parent.relationType}</h5>
        <div className="multiple-fields">
          <div>
            <h6>Nombre</h6>
            <p>{parent.firstName}</p>
          </div>
          <div>
            <h6>Apellido</h6>
            <p>{parent.lastName}</p>
          </div>
        </div>
        <div className="multiple-fields">
          <div>
            <h6>CI</h6>
            <p>{parent.ci}</p>
          </div>
          <div>
            <h6>Email</h6>
            <p>{parent.email || '-'}</p>
          </div>
        </div>
        <div className="multiple-fields">
          <div>
            <h6>Celular</h6>
            <p>{parent.phone}</p>
          </div>
          <div className="phones-multiple-fields">
            <div>
              <h6>Teléfono del trabajo</h6>
              <p>{parent.jobPhone || '-'}</p>
            </div>
            <div>
              <h6>Interno</h6>
              <p>{parent.internalJobPhone || '-'}</p>
            </div>
          </div>
        </div>
        <div className="multiple-fields">
          <div>
            <h6>Fecha de nacimiento</h6>
            <p>{moment(parent.birthdate).format('DD/MM/YYYY')}</p>
          </div>
          <div>
            <h6>Ocupación</h6>
            <p>{parent.occupation}</p>
          </div>
        </div>
        <div className="multiple-fields">
          <div>
            <h6>Tipo de relación</h6>
            <p>{parent.relationType}</p>
          </div>
          <div>
            <h6>Nivel educativo</h6>
            <p>{parent.educationLevel}</p>
          </div>
        </div>
        <hr />
      </div>
    )}
  </div>
);

const { array } = PropTypes;

StudentParentsInfo.propTypes = {
  parents: array.isRequired
};

export default StudentParentsInfo;



// WEBPACK FOOTER //
// ./src/components/student/StudentParentsInfo.js